import React from 'react';
import StoreProduct from '../../../../widgets/storeProduct/StoreProduct/StoreProduct';
import CategoryHeader from '../components/CategoryHeader/CategoryHeader';
import css from './StoreCategoryView.module.scss';

const StoreCategoryView = ({ category, subCategoriesData, product, qSearch, propertiesFilters, isLoadingPrice }) => {
    return (
        <div className={css.storeWrapper}>
            {category && category.data && <CategoryHeader category={category} subCategoriesData={subCategoriesData} />}
            <StoreProduct
                isLoadingPrice={isLoadingPrice}
                qSearch={qSearch}
                // mixStyles={css}
                product={product}
                category={category}
                propertiesFilters={propertiesFilters}
            />
        </div>
    );
};
export default StoreCategoryView;
